// ======================= Types =======================
export interface AudioFlags {
  isSimpleText: boolean;
  isURL: boolean;
  isImageSingle: boolean;
  isImageGallery: boolean;
  isAudio: boolean;
  isFile: boolean;
  isVideo: boolean;
  isHTML: boolean;
}

export interface AudioJsonData {
  file: string;
  audioBlobUrl: string;
  playbackTime: string;
  histogram: string[];
  audioDataUrl: string;
}

export interface AudioRecordedPayload {
  flags: AudioFlags;
  jsonData: AudioJsonData;
}

export interface AudioMessageRecorderProps {
  onAudioRecorded: (payload: AudioRecordedPayload) => void;
  setAudioMessageSubmitted: (value: boolean) => void;
  audioMessageSubmitted: boolean;
}

// ======================= Constants =======================
const MAX_FILE_SIZE_MB = 5; // Max file size in MB
const APPROX_BITRATE_KBPS = 128; // Approximate bitrate in Kbps
export const MAX_DURATION_SEC = (MAX_FILE_SIZE_MB * 1024) / (APPROX_BITRATE_KBPS / 8); // Max seconds allowed

// ======================= Helpers =======================
export function getAudioDuration(url: string): Promise<number> {
  return new Promise((resolve, reject) => {
    if (!url) {
      console.error('❌ No valid audio URL provided.');
      return reject('No valid audio URL provided.');
    }

    const audioElement = new Audio(url);
    audioElement.preload = 'metadata';

    audioElement.onloadedmetadata = () => {
      const duration = Math.floor(audioElement.duration); // ✅ Get actual duration in seconds
      resolve(duration);
    };

    audioElement.onerror = (err) => {
      console.error('❌ Error loading audio metadata:', err);
      reject(err);
    };
  });
}

export function arrayBufferToBase64(buffer: ArrayBuffer): string {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

export function formatTime(timeInMs: number): string {
  const totalSeconds = Math.floor(timeInMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const milliseconds = Math.floor((timeInMs % 1000) / 10);
  return `${minutes}:${seconds.toString().padStart(2, '0')},${milliseconds.toString().padStart(2, '0')}`;
}

export function formatPlaybackTime(timeInMs: number): string {
  const totalSeconds = Math.floor(timeInMs / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
